import { unwrapResponse } from "../../../../response.js";
import { authHeader, postJson, acceptJson } from "../../../../shared.js";
async function changePassword(apiUrl, accessToken, customerId, request) {
  return unwrapResponse(
    await fetch(`${apiUrl}/customers/account/password/${encodeURIComponent(customerId)}/change`, {
      method: "POST",
      headers: {
        ...acceptJson,
        ...postJson,
        ...authHeader(accessToken)
      },
      body: JSON.stringify(request)
    }),
    {
      useResponseError: true,
      responseErrorMapper: (result) => {
        return {
          auth0ErrorCode: result?.customData?.auth0ErrorCode
        };
      }
    }
  );
}
export {
  changePassword
};
//# sourceMappingURL=change.js.map
